import { InteractionRequiredAuthError, IPublicClientApplication } from "@azure/msal-browser";
import { loginRequest, mcpRequest } from "../authConfig";

export async function fetchCopilotResponse(
  instance: IPublicClientApplication,
  url: string,
  init: Parameters<typeof fetch>[1] = {}
): Promise<Response> {
  const username = sessionStorage.getItem("loginUserName");
  const accounts = instance.getAllAccounts();
  const account = username
    ? accounts.find((candidate) => candidate.username === username)
    : instance.getActiveAccount() ?? (accounts.length === 1 ? accounts[0] : null);
  if (!account) {
    throw new Error("Sign in again before sending a Copilot message.");
  }

  const acquireToken = async (scopes: string[]) => {
    try {
      return await instance.acquireTokenSilent({ scopes, account });
    } catch (error) {
      if (!(error instanceof InteractionRequiredAuthError)) throw error;
      return instance.acquireTokenPopup({ scopes, account });
    }
  };

  // Acquire separately: Entra access tokens have one resource audience.
  const apiToken = await acquireToken(loginRequest.scopes);
  const mcpToken = await acquireToken(mcpRequest.scopes);
  if (!apiToken.accessToken || !mcpToken.accessToken) {
    throw new Error("Unable to acquire the access tokens required for Copilot.");
  }
  if (init.signal?.aborted) {
    throw new DOMException("The request was aborted.", "AbortError");
  }

  const headers = new Headers(init.headers);
  headers.set("Authorization", `Bearer ${apiToken.accessToken}`);
  headers.set("X-MCP-Access-Token", mcpToken.accessToken);
  return fetch(url, { ...init, headers });
}
